import { ResourceAction } from '../../../authentication/authorization-service';
import { ResourceOperations, ResourceTypes } from '../../../authentication/resources';
import {
  attendanceAreaPathName,
  attendanceCitizenImport,
  attendanceClassroomsPathName,
  attendanceCourseMenuName,
  attendanceCoursesAreaPathName,
  attendanceEducatorsPathName,
  attendanceRegistrationCountersPathName,
} from '../../../areas/attendance/attendance-area-pathnames';
import { attendanceTabLabel, attendanceTabPathName, schedulePathName } from '../../../areas/citizen/authority/citizen-authority-area-pathnames';
import { citizensAreaAttendanceImportLabel } from '../../../areas/citizen/authority/overview/citizens-overview-area-pathnames';
import { OmnibarEntry } from '../omnibar-interfaces';
import { catalogCorrectionsToggle } from '../utils/catalog-corrections';

const attendanceToggles = [catalogCorrectionsToggle, 'EnableAttendance'];
const attendanceAddon = ['Attendance'];

const courseAccess: ResourceAction[] = [
  { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.Attendance },
  { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.Attendance },
  { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.AttendanceProtocol },
  { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceProtocol },
];
const facilityAccess: ResourceAction[] = [
  { resourceOperation: ResourceOperations.Read, resourceType: ResourceTypes.AttendanceFacility },
  { resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceFacility },
];

function attendancePage(id: string, label: string, path: string, resourceActions: ResourceAction[], featureToggleRequired = attendanceToggles): OmnibarEntry {
  return {
    id,
    label,
    keywords: ['fremmøde'],
    context: 'none',
    group: 'Fremmøde',
    url: `/${attendanceAreaPathName}/${path}`,
    resourceActions,
    featureToggleRequired,
    tenantAddonEnabled: attendanceAddon,
  };
}

const functions: OmnibarEntry[] = [
  attendancePage('4f2a9c71-8e3d-4b6a-9d15-c7e0b3a8f612', attendanceCourseMenuName, attendanceCoursesAreaPathName, courseAccess),
  attendancePage('b83e6d2f-1c7a-4e95-a4b0-5d9f2e7c3a18', 'Underviser', attendanceEducatorsPathName, facilityAccess),
  attendancePage('e5c1a7d9-3f8b-4a2e-b6d4-0a9c5e1f7b83', 'Lokaler', attendanceClassroomsPathName, facilityAccess),
  attendancePage('19d7f3b5-6a2c-4e8d-9f41-b3e8c0a6d257', 'Infostandere', attendanceRegistrationCountersPathName, facilityAccess),
  {
    id: '7a3e5c9b-2d4f-4b1a-8e6c-f9b2d7a0c364',
    label: citizensAreaAttendanceImportLabel,
    keywords: ['fremmøde'],
    context: 'none',
    group: 'Fremmøde',
    callbackFn: () => {
      window.open(`/${attendanceAreaPathName}/${attendanceCitizenImport}`);
    },
    resourceActions: [{ resourceOperation: ResourceOperations.Write, resourceType: ResourceTypes.AttendanceImport }],
    featureToggleRequired: attendanceToggles,
    tenantAddonEnabled: attendanceAddon,
  },
  {
    id: 'c6b9e2a4-5f1d-4c7e-a3b8-2e7d9f0c1a56',
    label: attendanceTabLabel,
    keywords: ['skema', 'hold'],
    context: 'citizen',
    group: 'Borgerområde',
    url: `/deeplink/citizen/:contextId/${attendanceTabPathName}`,
    featureToggleRequired: attendanceToggles,
    tenantAddonEnabled: attendanceAddon,
  },
  {
    id: '0e8d4b6f-3a7c-4f2e-9b15-d6a2c8e0f491',
    label: 'Borgers skema',
    keywords: ['fremmøde', 'hold'],
    context: 'citizen',
    group: 'Borgerområde',
    callbackFn: (contextId: string) => {
      window.open(`/deeplink/citizen/${contextId}/${schedulePathName}`);
    },
    featureToggleRequired: attendanceToggles,
    tenantAddonEnabled: attendanceAddon,
  },
];

export default functions;
